import { gsap } from 'gsap';

const initStickySections = (sections) => {
    sections.forEach(section => {
        const nextSection = section.parentNode.nextElementSibling;
        const cards = section.querySelectorAll('.js-sticky-card');
        const trigger = cards[cards.length - 1]; 

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger,
                start: 'top 40px',
                endTrigger: nextSection,
                end: 'top top',
                pin: section,
                pinSpacing: false,
                onEnter: () => {
                    section.classList.add('is-sticky');
                },
                onLeaveBack: () => {
                    section.classList.remove('is-sticky');
                }
            }
        });
    });
};

export default initStickySections;
